"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testSort = exports.filterRegexBy = exports.escapeRegExp = exports.compareProps = exports.not = exports.deepFreeze = exports.valueToString = exports.flatMap = exports.just = exports.assert = exports.maybePath = exports.withDefault = exports.isNumber = exports.isEmpty = exports.isObject = exports.isDefined = exports.ident = exports.noop = exports.NOPComponent = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _actions = require("./actions");

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

var _reducers = require("./reducers");

Object.keys(_reducers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _reducers[key];
    }
  });
});

var _fastDeepEqual = require("fast-deep-equal");

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var NOPComponent = exports.NOPComponent = function NOPComponent() {
  return null;
};

var noop = exports.noop = function noop() {};

var ident = exports.ident = function ident(x) {
  return x;
};

var isDefined = exports.isDefined = function isDefined(value) {
  return value != null;
};

var isObject = exports.isObject = function isObject(obj) {
  return isDefined(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
};

var isEmpty = exports.isEmpty = function isEmpty(obj) {
  if (obj == null) {
    return true;
  }

  if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== "object") {
    return true;
  }

  if (obj instanceof Array) {
    return obj.length === 0;
  } else {
    return Object.getOwnPropertyNames(obj).length > 0;
  }
};

var isNumber = exports.isNumber = function isNumber(number) {
  if (number != null && number !== "") {
    var coerced = Number(number);
    return !isNaN(coerced) && isFinite(coerced);
  } else {
    return false;
  }
};

var withDefault = exports.withDefault = function withDefault(value, d) {
  return value !== undefined && value !== null ? value : d;
};

var maybePath = exports.maybePath = function maybePath(obj) {
  for (var _len = arguments.length, path = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    path[_key - 1] = arguments[_key];
  }

  if (obj == null || path.length === 0) {
    return undefined;
  }

  var key = path[0];
  var rest = path.slice(1);

  if (obj instanceof Object && obj.hasOwnProperty(key)) {
    if (rest.length === 0) {
      return obj[key];
    } else {
      return maybePath.apply(undefined, [obj[key]].concat(_toConsumableArray(rest)));
    }
  }
};

var assert = exports.assert = function assert(condition, message) {
  if (!condition) {
    message = message || "Assertion failed";

    if (typeof Error !== "undefined") {
      throw new Error("AssertionError: " + message);
    }

    throw message;
  }
};

var just = exports.just = function just(value) {
  if (value != null) {
    return value;
  } else {
    throw new Error("ValueError: provided value is undefined and not `just`");
  }
};

var flatMap = exports.flatMap = function flatMap(arr, f) {
  return arr.reduce(function (x, y) {
    return [].concat(_toConsumableArray(x), _toConsumableArray(f(y)));
  }, []);
};

var valueToString = exports.valueToString = function valueToString(value) {
  if (value === undefined) {
    return "undefined";
  } else {
    return JSON.stringify(value);
  }
};

var _deepFreeze = function _deepFreeze(obj) {
  if (!isDefined(obj) || !isObject(obj) || typeof Object.isFrozen === "undefined" || Object.isFrozen(obj)) {
    return obj;
  }

  var propNames = Object.getOwnPropertyNames(obj);
  propNames.forEach(function (name) {
    var prop = obj[name];

    if (prop instanceof Array) {
      obj[name] = Object.freeze(prop.map(deepFreeze));
    } else if (isDefined(prop) && (typeof prop === "undefined" ? "undefined" : _typeof(prop)) === "object") {
      obj[name] = _deepFreeze(prop);
    }
  });
  return Object.freeze(obj);
};

var deepFreeze = exports.deepFreeze = process.env.NODE_ENV !== "development" ? ident : _deepFreeze;

var not = exports.not = function not(fun) {
  return function () {
    return !fun.apply(undefined, arguments);
  };
};

var compareProps = exports.compareProps = function compareProps() {
  for (var _len2 = arguments.length, deep = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    deep[_key2] = arguments[_key2];
  }

  return function (props, nextProps) {
    if (deep.length === 0) {
      return props === nextProps;
    }

    var namesProps = Object.getOwnPropertyNames(props).sort();
    var namesNextProps = Object.getOwnPropertyNames(nextProps).sort();

    if ((0, _fastDeepEqual2.default)(namesProps, namesNextProps)) {
      return namesProps.every(function (k) {
        if (deep.includes(k)) {
          return (0, _fastDeepEqual2.default)(props[k], nextProps[k]);
        } else {
          return props[k] === nextProps[k];
        }
      });
    } else {
      return false;
    }
  };
};

var escapeRegExp = exports.escapeRegExp = function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

var filterRegexBy = exports.filterRegexBy = function filterRegexBy(filter) {
  var lens = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JSON.stringify;
  var cleanFilter = filter.trim();

  if (cleanFilter === "") {
    return function () {
      return true;
    };
  }

  var regex = new RegExp(".*" + cleanFilter.split("").map(escapeRegExp).join(".*") + ".*", "i");
  return function (element) {
    return regex.test(lens(element));
  };
};

var testSort = exports.testSort = function testSort(comparator, array) {
  if (array.length < 2) {
    return array;
  }

  if (process.env.NODE_ENV !== "production") {
    var isSorted = array.every(function (value, index, array) {
      return index === 0 || comparator(array[index - 1], value) <= 0;
    });

    if (!isSorted) {
      console.warn("Provided array is unsorted according to " + comparator.name);
      return array.slice(0).sort(comparator);
    } else {
      return array;
    }
  } else {
    var lastIdx = array.length - 1;
    var testIdxs = [Math.round(lastIdx / 3), Math.round(lastIdx * 0.6666667), lastIdx];
    var previousElement = array[0];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = testIdxs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var testIdx = _step.value;
        var compareValue = comparator(previousElement, array[testIdx]);

        if (compareValue > 0) {
          console.warn("Provided array is unsorted sorted according to " + comparator.name + "!\n          " + valueToString(array[testIdx]) + "\n          is smaller than\n          " + valueToString(previousElement));
          return array.slice(0).sort(comparator);
        }

        previousElement = array[testIdx];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return array;
  }
};